module.exports = __webpack_public_path__ + "img/home_top4.fe4407c6.png";